import React, { useState } from "react";
import { Button, Form, DatePicker, Select } from "antd";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";
import { ContainerModal } from "../../container/ContainerModal";
import { typesPauses } from "../../../types/typePauses";

let formData = {};

export const FormPauses = ({ title = "Pausar proyecto", isNecesaryModal = false, pauseSelect = {}, type = 0, reasons = [], editFormForProjectDetails, closeModalDetails }) => {

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const [isModalEliminatePause, setIsModalEliminatePause] = useState(false);

    const finishForm = (values) => {
        formData = values;
        if (isNecesaryModal) {
            setIsModalEliminatePause(true);
        } else {
            sendFormPause();
        }
    };

    const sendFormPause = async () => {
        setLoading(true);
        const { init: initDate, end: finishDate, pause = [] } = formData;

        const structureMap = {
            [typesPauses.createPause]: {
                initDate,
                reasons: reasons.filter((element) => pause.includes(element.name)).map((reason) => reason._id),
            },
            [typesPauses.createPauseRange]: {
                initDate,
                finishDate,
                reasons: reasons.filter((element) => pause.includes(element.name)).map((reason) => reason._id),
            },
            [typesPauses.reactivePause]: {
                finishDate,
                idPause: pauseSelect.id,
                initPause: pauseSelect.date,
                reasons: pauseSelect.reasons.map((reason) => reason._id),
            },
        };

        const structureJson = {
            ...structureMap[type],
            typePauseSelect: type,
        };

        await editFormForProjectDetails(typeForDetailsProyect.pauses, structureJson);

        setLoading(false);
    };

    return (
        <>
            <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
                <ContainerModal
                    title={title}
                    actionButton={() => {
                        closeModalDetails();
                    }}
                    className={"w-[500px]"}
                >
                    {isModalEliminatePause && isNecesaryModal && (
                        <div className="fixed h-full w-full top-0 left-0 z-10 bg-black bg-opacity-50 flex justify-center items-center">
                            <div className="w-[400px] bg-white rounded-[4px] p-4 flex flex-col gap-4">
                                <div className="font-semibold">
                                    <p>Cambios</p>
                                </div>
                                <div className="">
                                    <p>¿Estas seguro de realizar los cambios?</p>
                                </div>
                                <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-center gap-4">
                                    <Button
                                        htmlType="button"
                                        onClick={() => {
                                            setIsModalEliminatePause(false);
                                        }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            sendFormPause();
                                        }}
                                        type="primary"
                                        htmlType="button"
                                        className="bg-primaryTwo"
                                    >
                                        Aceptar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                    <Form form={form} onFinish={finishForm} className="w-full h-full" layout="vertical">
                        <div className="grid grid-cols-2 gap-4">
                            {[typesPauses.createPauseRange, typesPauses.createPause].includes(type) && (
                                <Form.Item
                                    name={"init"}
                                    label="Inicio"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Necesita una fecha",
                                        },
                                    ]}
                                >
                                    <DatePicker className="w-full" />
                                </Form.Item>
                            )}
                            {[typesPauses.createPauseRange, typesPauses.reactivePause].includes(type) && (
                                <Form.Item
                                    name={"end"}
                                    label="Final"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Necesita una fecha",
                                        },
                                    ]}
                                >
                                    <DatePicker className="w-full" />
                                </Form.Item>
                            )}
                        </div>
                        {![typesPauses.reactivePause].includes(type) && (
                            <div className="">
                                <Form.Item
                                    name={"pause"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Escoge uno por lo menos",
                                        },
                                    ]}
                                    label="Motivos"
                                >
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        placeholder={`Selecciona uno`}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        {reasons.map((pauseReason, index) => (
                                            <Select.Option key={`${index}-pausemotivos`} value={pauseReason.name}>
                                                <span style={{ textTransform: "capitalize" }}>{pauseReason.name}</span>
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                        )}
                        <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
                            <Button htmlType="button" onClick={closeModalDetails}>
                                Cancelar
                            </Button>
                            <Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
                                Guardar
                            </Button>
                        </div>
                    </Form>
                </ContainerModal>
            </div>
        </>
    );
};
